import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'product/erasureHistory',
    pluginName: 'PRODUCT',
    entityName: 'ERASURE_HISTORY',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''

});

// Fetch ErasureHistory action creators
export const fetchErasureHistoryInit = () => { return crudActions.fetchInit(); }
export const fetchErasureHistoryStart = () => { return crudActions.fetchStart(); }
export const fetchErasureHistorySuccess = (fetchErasureHistoryCount, listErasureHistoryCount) => { return crudActions.fetchSuccess(fetchErasureHistoryCount, listErasureHistoryCount); }
export const fetchErasureHistoryFail = () => { return crudActions.fetchFail(); }

export const fetchErasureHistoryCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErasureHistoryStart());
        try {
            let countRes = await rest.post("product/erasureHistory/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchErasureHistorySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchErasureHistoryFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch erasure history."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchErasureHistoryFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch erasure history."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchErasureHistory = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErasureHistoryStart());
        try {
            let listRes = await rest.post("product/erasureHistory/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchErasureHistorySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchErasureHistoryFail());
            return []

        } catch (error) {
            dispatch(fetchErasureHistoryFail());
            return []

        }
    }
}

// Create CRUD action creator for palette
const paletteCrudActions = restCrudActions({
    endpointBasePath: 'product/paletteHistory',
    pluginName: 'PRODUCT',
    entityName: 'PALETTE_HISTORY',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch PaletteHistory action creators
export const fetchPaletteHistoryInit = () => { return paletteCrudActions.fetchInit(); }
export const fetchPaletteHistoryStart = () => { return paletteCrudActions.fetchStart(); }
export const fetchPaletteHistorySuccess = () => { return paletteCrudActions.fetchSuccess(); }
export const fetchPaletteHistoryFail = () => { return paletteCrudActions.fetchFail(); }


export const fetchPaletteHistoryCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPaletteHistoryStart());
        try {
            let countRes = await rest.post("product/paletteHistory/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchPaletteHistorySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchPaletteHistoryFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch palette history."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchPaletteHistoryFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch palette history."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchPaletteHistory = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPaletteHistoryStart());
        try {
            let listRes = await rest.post("product/paletteHistory/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchPaletteHistorySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchPaletteHistoryFail());
            return []

        } catch (error) {
            dispatch(fetchPaletteHistoryFail());
            return []

        }
    }
}

export const generateSessionReport = params => {
    const rest = getAxiosInstance();
    return async _dispatch => {
        try {
            let listRes = await rest.post("/product/erasureHistory/generate-erasure-session-report", params);
            if (listRes.data && listRes.data.succeeded) {
                snackActions.snackBar({
                    message: `Generating report in progress.`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            snackActions.snackBar({
                message: listRes?.data?.message || `Cannot generate processing session report. Please contact administrator.`,
                options: {
                    variant: listRes?.data?.message ? 'info' : 'error'
                }
            });
            return false;

        } catch (error) {
            snackActions.snackBar({
                message: error?.message || `Cannot generate processing session report. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;

        }
    }
}



